{
  /* Pantalla Visualizar Perfil */
}
import React, { useState } from 'react';
import { bool, arrayOf, number, shape } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER, propTypes } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/uiHelpers';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  Heading,
  H2,
  H4,
  Page,
  AvatarLarge,
  NamedLink,
  ListingCard,
  Reviews,
  ButtonTabNavHorizontal,
  LayoutSideNavigation,
} from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import location from '../../../src/assets/Location.svg';
import video from '../../../src/assets/Video.svg';
import trophy from '../../../src/assets/Trophy.svg';
import infoCircle from '../../../src/assets/Info-circle.svg';
import { ensureListing } from '../../util/data';
import { createSlug } from '../../util/urlHelpers';

import css from './ProfilePage.module.css';

const MAX_MOBILE_SCREEN_WIDTH = 768;

export const AsideContent = props => {
  const { user, displayName, isCurrentUser } = props;

  return (
    <div className={css.asideContent}>
      <AvatarLarge className={css.avatar} user={user} disableProfileLink />
      {/*<H2 as="h1" className={css.mobileHeading}>
        {displayName ? (
          <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: displayName }} />
        ) : null}
      </H2>*/}
      {isCurrentUser ? (
        <>
          <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
          </NamedLink>
          <NamedLink className={css.editLinkDesktop} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
          </NamedLink>
        </>
      ) : null}
    </div>
  );
};

export const ReviewsErrorMaybe = props => {
  const { queryReviewsError } = props;
  return queryReviewsError ? (
    <p className={css.error}>
      <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
    </p>
  ) : null;
};

export const MobileReviews = props => {
  const { reviews, queryReviewsError } = props;
  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  return (
    <div className={css.mobileReviews}>
      <H4 as="h2" className={css.mobileReviewsTitle}>
        <FormattedMessage
          id="ProfilePage.reviewsFromMyCustomersTitle"
          values={{ count: reviewsOfProvider.length }}
        />
      </H4>
      <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
      <Reviews reviews={reviewsOfProvider} />
      <H4 as="h2" className={css.mobileReviewsTitle}>
        <FormattedMessage
          id="ProfilePage.reviewsAsACustomerTitle"
          values={{ count: reviewsOfCustomer.length }}
        />
      </H4>
      <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
      <Reviews reviews={reviewsOfCustomer} />
    </div>
  );
};

export const DesktopReviews = props => {
  const [showReviewsType, setShowReviewsType] = useState(REVIEW_TYPE_OF_PROVIDER);
  const { reviews, queryReviewsError } = props;
  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;
  const desktopReviewTabs = [
    {
      text: (
        <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsFromMyCustomersTitle"
            values={{ count: reviewsOfProvider.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeProviderSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
    },
    {
      text: (
        <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsAsACustomerTitle"
            values={{ count: reviewsOfCustomer.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeCustomerSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
    },
  ];

  return (
    <div className={css.desktopReviews}>
      <div className={css.desktopReviewsWrapper}>
        <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />

        {isReviewTypeProviderSelected ? (
          <Reviews reviews={reviewsOfProvider} />
        ) : (
          <Reviews reviews={reviewsOfCustomer} />
        )}
      </div>
    </div>
  );
};

export const MainContent = props => {
  const {
    userShowError,
    bio,
    displayName,
    listings,
    queryListingsError,
    reviews,
    queryReviewsError,
    viewport,
    user,
    fullName,
    languages,
  } = props;

  const hasListings = listings.length > 0;
  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
  const hasBio = !!bio;
  const hasLanguages = languages?.length > 0;
  const validation = user && user?.attributes?.profile?.publicData?.['approve-experience'];
  let typeCoach = user?.attributes?.profile?.publicData['nivel-coach'];
  //formato coach
  typeCoach = typeCoach?.replace(/-/g, ' ');
  const firstLetter = typeCoach?.charAt(0);
  const remainingLetters = typeCoach?.substring(1);
  const firstLetterCap = firstLetter?.toUpperCase();
  typeCoach = firstLetterCap + remainingLetters;

  const approveForServices =
    user && user?.attributes?.profile?.publicData?.['approve-for-services'];

  const listingsContainerClasses = classNames(css.listingsContainer, {
    [css.withBioMissingAbove]: !hasBio,
  });

  const currentListing = ensureListing(listings && listings.length > 0 ? listings[0] : null);
  
  const id = listings && listings.length > 0 ? currentListing.id.uuid : null;
  const { title = '', price, publicData } = currentListing.attributes;
  const slug = createSlug(title);

  const typeListing = listings[0]?.attributes?.publicData?.visitType;
  const remoteVisit = listings[0]?.attributes?.publicData?.visitaEnLinea;
  const faceToFaceVisit = listings[0]?.attributes?.publicData?.visitaPresencial;

  if (userShowError || queryListingsError) {
    return (
      <p className={css.error}>
        <FormattedMessage id="ProfilePage.loadingDataFailed" />
      </p>
    );
  }

  return (
    <div className={css.fullNameContainer}>
      <div>
        <div className={css.desktopHeading}>
          {fullName.includes('undefined') ? (
            '...'
          ) : (
            <FormattedMessage
              id="ProfilePage.desktopHeading"
              values={{
                name: fullName,
              }}
            />
          )}
        </div>

        <div className={css.typeOfCouchContainer}>
          {validation ? (
            <>
              <img className={css.trophyIcon} src={trophy} />
              <div className={css.labelCouch}>{typeCoach}</div>
            </>
          ) : approveForServices ? (
            <>
              <img className={css.trophyIcon} src={infoCircle} />
              <div className={css.labelCouchWV}>En validación</div>
            </>
          ) : null}
        </div>
      </div>

      {hasBio ? <p className={css.bio}>{bio}</p> : null}

      {/*Idiomas */}
      <div className={css.languagesContainer}>
        <h4>Idiomas</h4>
        <div className={css.languagesUser}>
          {hasLanguages && languages
            ? languages.map((item, index) => {
                return (
                  <>
                    {index < languages.length - 1 ? (
                      <div>{`${item},`}</div>
                    ) : (
                      <div>{`${item}`}</div>
                    )}
                    <>&nbsp;</>
                  </>
                );
              })
            : null}
        </div>
      </div>

      {hasListings && approveForServices ? (
        <div className={css.servicesContainer}>
          <h4>Servicios</h4>

          {typeListing &&
            typeListing.length > 0 &&
            typeListing.map((item, index) => {
              return (
                <button className={css.buttonTypeSession}>
                  <img
                    className={css.iconButtonTypeSession}
                    src={item === 'Visita presencial' ? location : video}
                  />
                  {item}
                </button>
              );
            })}

          {remoteVisit && (
            <NamedLink className={css.buttonTypeSession} name="ListingPage" params={{ id, slug }}>
              <img className={css.iconButtonTypeSession} src={video} />
              Remoto
            </NamedLink>
          )}

          {faceToFaceVisit && (
            <NamedLink className={css.buttonTypeSession} name="ListingPage" params={{ id, slug }}>
              <img className={css.iconButtonTypeSession} src={location} /> Presencial
            </NamedLink>
          )}
        </div>
      ) : null}

      {/*

Reviews QUITAR PROXIMAMENTE
      {isMobileLayout && approveForServices ? (
        <MobileReviews reviews={reviews} queryReviewsError={queryReviewsError} />
      ) : (
        approveForServices && (
          <DesktopReviews reviews={reviews} queryReviewsError={queryReviewsError} />
        )
      )}
      */}
    </div>
  );
};

const ProfilePageComponent = props => {
  const config = useConfiguration();
  const { scrollingDisabled, currentUser, userShowError, user, intl, listings, ...rest } = props;
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const profileUser = ensureUser(user);
  const isCurrentUser =
    ensuredCurrentUser.id && profileUser.id && ensuredCurrentUser.id.uuid === profileUser.id.uuid;
  const { bio, displayName } = profileUser?.attributes?.profile || {};
  const schemaTitleVars = { name: displayName, marketplaceName: config.marketplaceName };
  const schemaTitle = intl.formatMessage({ id: 'ProfilePage.schemaTitle' }, schemaTitleVars);
  //const fullName = `${ensuredCurrentUser?.attributes?.profile?.firstName} ${ensuredCurrentUser?.attributes?.profile?.lastName}`;
  //const fullName = displayName;
  let fullName = '';
  if (listings.length > 0) {
    fullName = listings[0]?.attributes?.publicData?.author;
  } else {
    fullName = `${ensuredCurrentUser?.attributes?.profile?.firstName} ${ensuredCurrentUser?.attributes?.profile?.lastName}`;
  }
  const languages = ensuredCurrentUser?.attributes?.profile?.publicData?.languages;
  const hasLanguages = ensuredCurrentUser?.attributes?.profile?.publicData?.languages > 0;
  const hasCountry = ensuredCurrentUser?.attributes?.profile?.publicData?.languages?.country;
  const hasBio = !!bio;

  if (userShowError && userShowError.status === 404) {
    return <NotFoundPage />;
  }

  const validation =
    profileUser && profileUser?.attributes?.profile?.publicData?.['approve-experience'];

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ProfilePage',
        name: schemaTitle,
      }}
    >
      <LayoutSideNavigation
        sideNavClassName={css.aside}
        topbar={<TopbarContainer currentPage="ProfilePage" />}
        sideNav={
          <AsideContent user={user} isCurrentUser={isCurrentUser} displayName={displayName} />
        }
        footer={<FooterContainer />}
      >
        <MainContent
          bio={bio}
          displayName={displayName}
          userShowError={userShowError}
          fullName={fullName}
          languages={languages}
          user={user}
          listings={listings}
          {...rest}
        />

        {!validation && !hasBio && !hasLanguages && !hasCountry && (
          <div style={{ color: '#75767A', fontSize: '12px', wordWrap: 'break-word' }}>
            Sin información
          </div>
        )}
      </LayoutSideNavigation>
    </Page>
  );
};

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
};

ProfilePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  user: propTypes.user,
  userShowError: propTypes.error,
  queryListingsError: propTypes.error,
  listings: arrayOf(propTypes.listing).isRequired,
  reviews: arrayOf(propTypes.review),
  queryReviewsError: propTypes.error,

  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews,
    queryReviewsError,
  } = state.ProfilePage;
  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);
  const user = userMatches.length === 1 ? userMatches[0] : null;
  const listings = getMarketplaceEntities(state, userListingRefs);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    user,
    userShowError,
    queryListingsError,
    listings,
    reviews,
    queryReviewsError,
  };
};

const ProfilePage = compose(
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(ProfilePageComponent);

export default ProfilePage;
